import React, { useState } from 'react';
import { Search, Globe, AlertCircle, ExternalLink, Loader2, Share2, Copy, Check } from 'lucide-react';

// SVG brand icons
const SocialIcons = {
  facebook: ({ size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#1877F2"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
  ),
  twitter: ({ size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className="text-gray-900 dark:text-white"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
  ),
  linkedin: ({ size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#0A66C2"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
  ),
  instagram: ({ size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#E4405F"><path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678a6.162 6.162 0 100 12.324 6.162 6.162 0 100-12.324zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405a1.441 1.441 0 11-2.882 0 1.441 1.441 0 012.882 0z"/></svg>
  ),
  youtube: ({ size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#FF0000"><path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
  ),
  tiktok: ({ size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className="text-gray-900 dark:text-white"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>
  ),
  pinterest: ({ size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#BD081C"><path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 01.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12.017 24c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641 0 12.017 0z"/></svg>
  ),
  telegram: ({ size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#26A5E4"><path d="M11.944 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0a12 12 0 00-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 01.171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>
  ),
  discord: ({ size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#5865F2"><path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189z"/></svg>
  ),
  reddit: ({ size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#FF4500"><path d="M12 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 01-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 01.042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.534A1.748 1.748 0 014.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 01.14-.197.35.35 0 01.238-.042l2.906.617a1.214 1.214 0 011.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248.687 0 1.248-.561 1.248-1.249 0-.688-.561-1.249-1.249-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25 0 .687.561 1.248 1.249 1.248.688 0 1.249-.561 1.249-1.249 0-.687-.562-1.249-1.25-1.249zm-5.466 3.99a.327.327 0 00-.231.094.33.33 0 000 .463c.842.842 2.484.913 2.961.913.477 0 2.105-.056 2.961-.913a.361.361 0 000-.462.342.342 0 00-.465 0c-.533.533-1.684.73-2.512.73-.828 0-1.979-.196-2.512-.73a.326.326 0 00-.232-.095z"/></svg>
  ),
  whatsapp: ({ size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#25D366"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
  ),
};

const platformConfig = {
  facebook: { label: 'Facebook', brandBg: 'bg-[#1877F2]', cardBg: 'bg-white dark:bg-slate-800', borderColor: 'border-[#1877F2]/20 dark:border-[#1877F2]/30' },
  twitter: { label: 'X (Twitter)', brandBg: 'bg-black dark:bg-white', cardBg: 'bg-white dark:bg-slate-800', borderColor: 'border-gray-200 dark:border-slate-600' },
  linkedin: { label: 'LinkedIn', brandBg: 'bg-[#0A66C2]', cardBg: 'bg-white dark:bg-slate-800', borderColor: 'border-[#0A66C2]/20 dark:border-[#0A66C2]/30' },
  instagram: { label: 'Instagram', brandBg: 'bg-gradient-to-br from-[#F58529] via-[#DD2A7B] to-[#8134AF]', cardBg: 'bg-white dark:bg-slate-800', borderColor: 'border-[#DD2A7B]/20 dark:border-[#DD2A7B]/30' },
  youtube: { label: 'YouTube', brandBg: 'bg-[#FF0000]', cardBg: 'bg-white dark:bg-slate-800', borderColor: 'border-[#FF0000]/20 dark:border-[#FF0000]/30' },
  tiktok: { label: 'TikTok', brandBg: 'bg-black dark:bg-white', cardBg: 'bg-white dark:bg-slate-800', borderColor: 'border-gray-200 dark:border-slate-600' },
  pinterest: { label: 'Pinterest', brandBg: 'bg-[#BD081C]', cardBg: 'bg-white dark:bg-slate-800', borderColor: 'border-[#BD081C]/20 dark:border-[#BD081C]/30' },
  telegram: { label: 'Telegram', brandBg: 'bg-[#26A5E4]', cardBg: 'bg-white dark:bg-slate-800', borderColor: 'border-[#26A5E4]/20 dark:border-[#26A5E4]/30' },
  discord: { label: 'Discord', brandBg: 'bg-[#5865F2]', cardBg: 'bg-white dark:bg-slate-800', borderColor: 'border-[#5865F2]/20 dark:border-[#5865F2]/30' },
  reddit: { label: 'Reddit', brandBg: 'bg-[#FF4500]', cardBg: 'bg-white dark:bg-slate-800', borderColor: 'border-[#FF4500]/20 dark:border-[#FF4500]/30' },
  whatsapp: { label: 'WhatsApp', brandBg: 'bg-[#25D366]', cardBg: 'bg-white dark:bg-slate-800', borderColor: 'border-[#25D366]/20 dark:border-[#25D366]/30' },
};

const SocialMediaFinder = () => {
  const [url, setUrl] = useState('');
  const [socialMedia, setSocialMedia] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [searchedDomain, setSearchedDomain] = useState('');
  const [source, setSource] = useState('');
  const [usage, setUsage] = useState(null);
  const [copiedUrl, setCopiedUrl] = useState(null);
  const [userEmail, setUserEmail] = useState('');

  const basePath = process.env.REACT_APP_API_URL || '';

  // Fetch user email on mount to check admin access
  React.useEffect(() => {
    fetch(`${basePath}/api/auth/verify-session`, { credentials: 'include' })
      .then(res => res.json())
      .then(data => {
        if (data.user?.email) setUserEmail(data.user.email);
      })
      .catch(() => {});
  }, [basePath]);

  const extractDomain = (input) => {
    let cleaned = input.trim().toLowerCase();
    cleaned = cleaned.replace(/^https?:\/\//, '');
    cleaned = cleaned.replace(/^www\./, '');
    cleaned = cleaned.split('/')[0];
    cleaned = cleaned.split('?')[0];
    return cleaned;
  };

  const handleSubmit = async (forceRefresh = false) => {
    setError('');
    setSocialMedia({});
    setSearchedDomain('');
    setSource('');

    if (!url.trim()) {
      setError('Please enter a domain or website URL.');
      return;
    }

    const domain = extractDomain(url);
    const domainRegex = /^[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]?\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/;
    if (!domain || !domainRegex.test(domain)) {
      setError('Please enter a valid domain (e.g., example.com).');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${basePath}/api/social-media-finder`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ url: domain, forceRefresh })
      });

      let data;
      try {
        data = await response.json();
      } catch {
        throw new Error('Invalid response from server.');
      }

      if (!response.ok) {
        if (response.status === 403 && data.error === 'SOCIAL_MEDIA_FINDER_LIMIT_EXCEEDED') {
          throw new Error(data.message || 'Limit exceeded. Please upgrade your plan.');
        }
        throw new Error(data.message || `Request failed with status ${response.status}`);
      }

      if (!data.success) {
        throw new Error(data.message || 'Failed to find social media.');
      }

      setSocialMedia(data.socialMedia || {});
      setSearchedDomain(data.domain || domain);
      setSource(data.source || '');
      if (data.usage) setUsage(data.usage);

    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !loading) {
      handleSubmit();
    }
  };

  const handleCopy = (linkUrl) => {
    navigator.clipboard.writeText(linkUrl);
    setCopiedUrl(linkUrl);
    setTimeout(() => setCopiedUrl(null), 2000);
  };

  const hasResults = Object.values(socialMedia).some(arr => arr && arr.length > 0);
  const totalLinks = Object.values(socialMedia).flat().filter(Boolean).length;

  return (
    <div className="p-4 min-h-screen bg-gray-100 dark:bg-slate-950" style={{ fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif' }}>

      {/* Header */}
      <div className="mb-6">
        <div className="bg-white dark:bg-slate-900 rounded-xl border border-gray-200 dark:border-slate-700 shadow-sm p-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-semibold mb-2 text-gray-800 dark:text-slate-100 flex items-center gap-3">
                <div className="p-2 bg-gradient-to-r from-blue-600 to-blue-700 dark:from-blue-700 dark:to-blue-800 rounded-lg">
                  <Share2 className="w-6 h-6 text-white" />
                </div>
                Social Media Finder
              </h1>
              <p className="text-gray-600 dark:text-slate-400 leading-relaxed max-w-xl">
                Find social media profiles for any website
              </p>
              <p className="text-sm text-blue-500 dark:text-blue-400 mt-2">Enter a domain like: example.com, company.com, or https://website.com</p>
            </div>
            <div className="flex items-center gap-4">
              <div className="px-4 py-2 bg-gradient-to-r from-blue-50 to-blue-100 dark:from-blue-900/30 dark:to-blue-800/30 rounded-lg border border-blue-200 dark:border-blue-700 shadow-sm">
                <span className="text-sm font-medium text-blue-600 dark:text-blue-400">Social Discovery Suite</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Search Form */}
      <div className="mb-6">
        <div className="bg-white dark:bg-slate-900 rounded-xl border border-gray-200 dark:border-slate-700 shadow-sm p-6">
          <div className="flex items-center gap-2 mb-6">
            <Globe className="w-5 h-5 text-blue-600 dark:text-blue-400" />
            <h2 className="text-lg font-medium text-gray-800 dark:text-slate-100">Domain Social Media Search</h2>
          </div>

          <div className="flex flex-col lg:flex-row lg:items-end gap-4">
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-2">
                Enter Domain or Website URL
              </label>
              <input
                type="text"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="e.g., example.com or https://example.com"
                className="w-full px-4 py-3 border border-gray-200 dark:border-slate-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-600 focus:border-blue-500 dark:focus:border-blue-600 transition-all duration-200 hover:shadow-md h-12 bg-white dark:bg-slate-800 text-gray-900 dark:text-slate-100"
                disabled={loading}
              />
            </div>

            <div className="lg:w-56 w-full">
              <button
                onClick={() => handleSubmit(false)}
                disabled={loading || !url.trim()}
                className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 disabled:from-gray-400 disabled:to-gray-500 text-white font-medium px-4 rounded-lg transition-all duration-300 flex items-center justify-center gap-2 transform hover:scale-105 hover:shadow-lg shadow-blue-600/30 hover:shadow-blue-600/40 disabled:transform-none disabled:shadow-none h-12"
              >
                {loading ? (
                  <div className="animate-spin w-5 h-5 border-2 border-white border-t-transparent rounded-full" />
                ) : (
                  <Search className="w-4 h-4" />
                )}
                <span>{loading ? 'Searching...' : 'Find Social Media'}</span>
              </button>
            </div>
          </div>

          {/* Usage info */}
          {usage && usage.allowed !== -1 && (
            <div className="mt-4 text-xs text-gray-400 dark:text-slate-500">
              Usage: {usage.currentCount}/{usage.allowed} lookups ({usage.remaining} remaining)
            </div>
          )}
        </div>
      </div>

      {/* Error Message */}
      {error && (
        <div className="mb-6">
          <div className="bg-red-50 dark:bg-red-900 border border-red-200 dark:border-red-700 rounded-xl p-4 flex items-center gap-2">
            <AlertCircle className="text-red-500 dark:text-red-400" size={20} />
            <span className="text-red-700 dark:text-red-300">{error}</span>
          </div>
        </div>
      )}

      {/* Results - Social Media Section */}
      {searchedDomain && (
        <div className="mb-6">
          <div className="bg-white dark:bg-slate-900 rounded-xl border border-gray-200 dark:border-slate-700 shadow-sm p-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-semibold text-gray-800 dark:text-slate-100">
                Social Media Profiles
                <span className="text-sm font-normal text-gray-500 dark:text-slate-400 ml-2">
                  {searchedDomain}
                </span>
              </h2>
              <div className="flex items-center gap-2">
                {hasResults && (
                  <span className="px-3 py-1 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400 rounded-full text-xs font-medium">
                    {totalLinks} found
                  </span>
                )}
                {source === 'cache' && (
                  <span className="px-3 py-1 bg-gray-100 dark:bg-slate-800 text-gray-500 dark:text-slate-400 rounded-full text-xs">
                    cached
                  </span>
                )}
                {source === 'cache' && userEmail === 'mars.mediacle@gmail.com' && (
                  <button
                    onClick={() => handleSubmit(true)}
                    disabled={loading}
                    className="px-3 py-1 bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-400 rounded-full text-xs font-medium hover:bg-orange-200 dark:hover:bg-orange-900/50 transition-colors"
                  >
                    Re-scan
                  </button>
                )}
              </div>
            </div>

            {hasResults ? (
              <div className="flex flex-wrap gap-3">
                {Object.entries(socialMedia).map(([platform, urls]) => {
                  if (!urls || urls.length === 0) return null;
                  const config = platformConfig[platform] || {
                    label: platform.charAt(0).toUpperCase() + platform.slice(1),
                    brandBg: 'bg-gray-500',
                    cardBg: 'bg-white dark:bg-slate-800',
                    borderColor: 'border-gray-200 dark:border-slate-700'
                  };
                  const IconComponent = SocialIcons[platform];

                  return urls.map((linkUrl, idx) => (
                    <a
                      key={`${platform}-${idx}`}
                      href={linkUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-200 border hover:shadow-md transform hover:scale-105 ${config.cardBg} ${config.borderColor}`}
                    >
                      <div className={`flex items-center justify-center w-8 h-8 rounded-md ${config.brandBg} flex-shrink-0`}>
                        {IconComponent
                          ? <div className={`${(platform === 'twitter' || platform === 'tiktok') ? '[&_svg]:fill-white dark:[&_svg]:fill-black' : '[&_svg]:fill-white'}`}><IconComponent size={16} /></div>
                          : <Share2 size={14} className="text-white" />
                        }
                      </div>
                      <div className="min-w-0">
                        <span className="font-medium text-gray-800 dark:text-slate-100 text-sm">{config.label}</span>
                        <p className="text-xs text-gray-500 dark:text-slate-400 truncate max-w-48">{linkUrl.replace(/^https?:\/\//, '').replace(/^www\./, '')}</p>
                      </div>
                      <ExternalLink size={14} className="flex-shrink-0 text-gray-400 dark:text-slate-500 ml-1" />
                    </a>
                  ));
                })}
              </div>
            ) : (
              <div className="text-center py-8 text-gray-400 dark:text-slate-500">
                <Share2 size={40} className="mx-auto mb-3 opacity-30" />
                <p>No social media links were found on this website.</p>
                <p className="text-xs mt-1">The website may not have social media links on its homepage.</p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Empty state */}
      {!searchedDomain && !loading && !error && (
        <div className="text-center py-16">
          <Share2 size={48} className="mx-auto mb-4 text-gray-300 dark:text-slate-600" />
          <h3 className="text-lg font-medium text-gray-500 dark:text-slate-400 mb-2">
            Enter a website URL to find its social media profiles
          </h3>
          <p className="text-sm text-gray-400 dark:text-slate-500">
            We'll scan the website and extract all social media links including Facebook, Twitter, LinkedIn, Instagram, YouTube, TikTok, and more.
          </p>
        </div>
      )}
    </div>
  );
};

export default SocialMediaFinder;
